import {
  getInitialState as rawGetInitialState,
  resetForm as rawResetForm,
  useForm as rawUseForm,
  validation as rawValidation,
} from '@magical-forms/react-next';

import type {
  Field,
  Form,
  FormState,
  InitialValueInput,
} from './magicalFormsTypes';

type AllowEmptyIfUndefined<T> = (undefined extends T ? [] : never) | [T];

export const validation = rawValidation;

export function getInitialState<TField extends Field>(
  rootField: TField,
  ...initialValue: AllowEmptyIfUndefined<InitialValueInput<TField>>
): FormState<TField> {
  return rawGetInitialState(rootField, ...(initialValue as any)) as FormState<
    TField
  >;
}

export function useForm<TField extends Field>(
  rootField: TField,
  ...initialValue: AllowEmptyIfUndefined<InitialValueInput<TField>>
): Form<TField> {
  return rawUseForm(rootField, ...(initialValue as any)) as Form<TField>;
}

export function resetForm<TField extends Field>(
  ...args: undefined extends InitialValueInput<TField>
    ? [Form<TField>] | [Form<TField>, InitialValueInput<TField>]
    : [Form<TField>, InitialValueInput<TField>]
) {
  rawResetForm(...(args as any));
}
